// extracted by mini-css-extract-plugin
module.exports = {"kanboUserPicker":"KanBoUserPicker_kanboUserPicker__23KlM","searchInputWrapper":"KanBoUserPicker_searchInputWrapper__2Yd4U"};